export default __webpack_public_path__ + "svg/calendar/2025/9/noviembre.svg?ed60d24a";